import axios from 'axios';
import api from './config';

// Game invitation API endpoint
const GAME_INVITATION_API_URL = '/games/invitation';

/**
 * Send an invitation to join a game to another user
 * @param fromUsername - The username of the inviter
 * @param toUsername - The username of the user being invited
 * @param gameID - The ID of the game to invite to
 * @returns A promise with the result of the invitation
 */
const sendGameInvitation = async (
  fromUsername: string,
  toUsername: string,
  gameID: string,
): Promise<{ message: string }> => {
  try {
    const url = `${GAME_INVITATION_API_URL}/invite`;

    const response = await api.post(url, {
      fromUsername,
      toUsername,
      gameID,
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const statusCode = error.response?.status;
      const responseData = error.response?.data;

      if (statusCode === 404) {
        throw new Error(
          `API endpoint not found: ${error.config?.url}. Please check if the server is running and the endpoint is correctly configured.`,
        );
      }

      if (responseData) {
        let errorMessage = '';

        if (typeof responseData === 'string') {
          errorMessage = responseData;
        } else if (typeof responseData === 'object') {
          if (responseData.error) {
            errorMessage = responseData.error;
          } else if (responseData.message) {
            errorMessage = responseData.message;
          } else {
            errorMessage = JSON.stringify(responseData);
          }
        }

        throw new Error(`Error sending game invitation: ${errorMessage}`);
      }
    }

    throw error; // Re-throw the original error if it's not an Axios error or we couldn't extract details
  }
};

export default { sendGameInvitation };
